/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ChartBean', 'model/IStatisticsBean', 'model/IStatisticsResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ChartBean'), require('./IStatisticsBean'), require('./IStatisticsResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.IStatisticsResponse = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.ChartBean, root.BpmbuildProductionappspotcom.IStatisticsBean, root.BpmbuildProductionappspotcom.IStatisticsResponse);
  }
}(this, function(ApiClient, ChartBean, IStatisticsBean, IStatisticsResponse) {
  'use strict';

  /**
   * The IStatisticsResponse model module.
   * @module model/IStatisticsResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>IStatisticsResponse</code>.
   * @alias module:model/IStatisticsResponse
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>IStatisticsResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IStatisticsResponse} obj Optional instance to populate.
   * @return {module:model/IStatisticsResponse} The populated <code>IStatisticsResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('customComparisonDateFrom'))
        obj.customComparisonDateFrom = ApiClient.convertToType(data['customComparisonDateFrom'], 'Date');
      if (data.hasOwnProperty('statisticsDisplay'))
        obj.statisticsDisplay = ApiClient.convertToType(data['statisticsDisplay'], [ChartBean]);
      if (data.hasOwnProperty('customOptionDateFrom'))
        obj.customOptionDateFrom = ApiClient.convertToType(data['customOptionDateFrom'], 'Date');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = IStatisticsBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('optionString'))
        obj.optionString = ApiClient.convertToType(data['optionString'], 'String');
      if (data.hasOwnProperty('statisticsList'))
        obj.statisticsList = ApiClient.convertToType(data['statisticsList'], [IStatisticsResponse]);
      if (data.hasOwnProperty('comparisonType'))
        obj.comparisonType = ApiClient.convertToType(data['comparisonType'], 'String');
      if (data.hasOwnProperty('reportType'))
        obj.reportType = ApiClient.convertToType(data['reportType'], 'String');
      if (data.hasOwnProperty('comparisonString'))
        obj.comparisonString = ApiClient.convertToType(data['comparisonString'], 'String');
      if (data.hasOwnProperty('productList'))
        obj.productList = ApiClient.convertToType(data['productList'], ['String']);
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('chartType'))
        obj.chartType = ApiClient.convertToType(data['chartType'], 'String');
      if (data.hasOwnProperty('customComparisonDateTo'))
        obj.customComparisonDateTo = ApiClient.convertToType(data['customComparisonDateTo'], 'Date');
      if (data.hasOwnProperty('customOptionDateTo'))
        obj.customOptionDateTo = ApiClient.convertToType(data['customOptionDateTo'], 'Date');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {Date} customComparisonDateFrom
   */
  exports.prototype.customComparisonDateFrom = undefined;

  /**
   * @member {Array.<module:model/ChartBean>} statisticsDisplay
   */
  exports.prototype.statisticsDisplay = undefined;

  /**
   * @member {Date} customOptionDateFrom
   */
  exports.prototype.customOptionDateFrom = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {module:model/IStatisticsBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {module:model/IStatisticsResponse.OptionStringEnum} optionString
   */
  exports.prototype.optionString = undefined;

  /**
   * @member {Array.<module:model/IStatisticsResponse>} statisticsList
   */
  exports.prototype.statisticsList = undefined;

  /**
   * @member {module:model/IStatisticsResponse.ComparisonTypeEnum} comparisonType
   */
  exports.prototype.comparisonType = undefined;

  /**
   * @member {module:model/IStatisticsResponse.ReportTypeEnum} reportType
   */
  exports.prototype.reportType = undefined;

  /**
   * @member {module:model/IStatisticsResponse.ComparisonStringEnum} comparisonString
   */
  exports.prototype.comparisonString = undefined;

  /**
   * @member {Array.<String>} productList
   */
  exports.prototype.productList = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {module:model/IStatisticsResponse.ChartTypeEnum} chartType
   */
  exports.prototype.chartType = undefined;

  /**
   * @member {Date} customComparisonDateTo
   */
  exports.prototype.customComparisonDateTo = undefined;

  /**
   * @member {Date} customOptionDateTo
   */
  exports.prototype.customOptionDateTo = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;


  /**
   * Allowed values for the <code>optionString</code> property.
   * @enum {String}
   * @readonly
   */
  exports.OptionStringEnum = {
    /**
     * value: "TODAY"
     * @const
     */
    TODAY: "TODAY",

    /**
     * value: "YESTERDAY"
     * @const
     */
    YESTERDAY: "YESTERDAY",

    /**
     * value: "LAST7DAYS"
     * @const
     */
    lAST7DAYS: "LAST7DAYS",

    /**
     * value: "THISWEEK"
     * @const
     */
    THISWEEK: "THISWEEK",

    /**
     * value: "LASTWEEK"
     * @const
     */
    LASTWEEK: "LASTWEEK",

    /**
     * value: "LAST30DAYS"
     * @const
     */
    lAST30DAYS: "LAST30DAYS",

    /**
     * value: "THISMONTH"
     * @const
     */
    THISMONTH: "THISMONTH",

    /**
     * value: "LASTMONTH"
     * @const
     */
    LASTMONTH: "LASTMONTH",

    /**
     * value: "LAST365DAYS"
     * @const
     */
    lAST365DAYS: "LAST365DAYS",

    /**
     * value: "THISYEAR"
     * @const
     */
    THISYEAR: "THISYEAR",

    /**
     * value: "LASTYEAR"
     * @const
     */
    LASTYEAR: "LASTYEAR"
  };


  /**
   * Allowed values for the <code>comparisonType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ComparisonTypeEnum = {
    /**
     * value: "DAY"
     * @const
     */
    DAY: "DAY",

    /**
     * value: "WEEK"
     * @const
     */
    WEEK: "WEEK",

    /**
     * value: "MONTH"
     * @const
     */
    MONTH: "MONTH",

    /**
     * value: "YEAR"
     * @const
     */
    YEAR: "YEAR",

    /**
     * value: "CUSTOM"
     * @const
     */
    CUSTOM: "CUSTOM"
  };


  /**
   * Allowed values for the <code>reportType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ReportTypeEnum = {
    /**
     * value: "LEADTIME"
     * @const
     */
    LEADTIME: "LEADTIME",

    /**
     * value: "CYCLETIME"
     * @const
     */
    CYCLETIME: "CYCLETIME"
  };


  /**
   * Allowed values for the <code>comparisonString</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ComparisonStringEnum = {
    /**
     * value: "PREVIOUSDAY"
     * @const
     */
    PREVIOUSDAY: "PREVIOUSDAY",

    /**
     * value: "SAMEDAYLASTWEEK"
     * @const
     */
    SAMEDAYLASTWEEK: "SAMEDAYLASTWEEK",

    /**
     * value: "SAMEDAYLASTYEAR"
     * @const
     */
    SAMEDAYLASTYEAR: "SAMEDAYLASTYEAR",

    /**
     * value: "SAMEDAYOFWEEKLASTYEAR"
     * @const
     */
    SAMEDAYOFWEEKLASTYEAR: "SAMEDAYOFWEEKLASTYEAR",

    /**
     * value: "PREVIOUSPERIOD"
     * @const
     */
    PREVIOUSPERIOD: "PREVIOUSPERIOD",

    /**
     * value: "FOURWEEKSAGO"
     * @const
     */
    FOURWEEKSAGO: "FOURWEEKSAGO",

    /**
     * value: "SAMEWEEKLASTYEAR"
     * @const
     */
    SAMEWEEKLASTYEAR: "SAMEWEEKLASTYEAR",

    /**
     * value: "SAMEPERIODLASTYEAR"
     * @const
     */
    SAMEPERIODLASTYEAR: "SAMEPERIODLASTYEAR",

    /**
     * value: "FIFTYTWOWEEKSAGO"
     * @const
     */
    FIFTYTWOWEEKSAGO: "FIFTYTWOWEEKSAGO",

    /**
     * value: "PREVIOUSYEAR"
     * @const
     */
    PREVIOUSYEAR: "PREVIOUSYEAR"
  };


  /**
   * Allowed values for the <code>chartType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ChartTypeEnum = {
    /**
     * value: "PIE"
     * @const
     */
    PIE: "PIE",

    /**
     * value: "AREA"
     * @const
     */
    AREA: "AREA",

    /**
     * value: "BAR"
     * @const
     */
    BAR: "BAR",

    /**
     * value: "TIMELINE"
     * @const
     */
    TIMELINE: "TIMELINE",

    /**
     * value: "GUAGE"
     * @const
     */
    GUAGE: "GUAGE",

    /**
     * value: "COMBO"
     * @const
     */
    COMBO: "COMBO",

    /**
     * value: "GANTT"
     * @const
     */
    GANTT: "GANTT",

    /**
     * value: "BUBBLE"
     * @const
     */
    BUBBLE: "BUBBLE"
  };

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/IStatisticsResponse.js